export default __webpack_public_path__ + "static/media/impact.415a9f98.svg";